import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect(){
    this.promptRefresh();
  }

  promptRefresh(){
    swal.fire( { // eslint-disable-line no-undef
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonColor: "#d9534f",
      confirmButtonText: "Refresh",
      html: "A new instance has been assigned.<br><b>Please refresh to continue.</b>",
      icon: "warning",
      showLoaderOnConfirm: true,
      title: "Instance Updated",
      preConfirm: () => {
        window.location.hash = window.location.hash.replace( /^#(connect|control|presentation).*/, "#$1" );
        window.location.reload();
      }
    } );
  }
}
